import React from "react";
import { ChevronDown } from "lucide-react";
import Styles from "./Components.module.scss";

const LucidDropdown = ({
  showDropdown,
  setShowDropdown,
  selectedValue,
  setSelectedValue,
  setCurrentPage,
  options,
  placeholder,
  allLabel,
  onOpen,
}) => {
  return (
    <div className={Styles.lucidDropdown}>
      <button
        onClick={() => {
          setShowDropdown(!showDropdown);
          if (onOpen) onOpen();
        }}
        className={Styles.selectButton}
      >
        <span
          className={`${Styles.selectValue} ${
            selectedValue
              ? Styles.selectValueActive
              : Styles.selectValuePlaceholder
          }`}
        >
          {selectedValue || placeholder}
        </span>
        <ChevronDown
          className={`${Styles.chevronIcon} ${showDropdown ? Styles.chevronIconOpen : ""}`}
          strokeWidth={1.5}
        />
      </button>
      {showDropdown && (
        <div className={Styles.selectDropdown}>
          <button
            onClick={() => {
              setSelectedValue("");
              setShowDropdown(false);
              setCurrentPage(1);
            }}
            className={`${Styles.selectOption} ${
              !selectedValue
                ? Styles.selectOptionActive
                : Styles.selectOptionInactive
            }`}
          >
            {allLabel}
          </button>
          {options.map((option) => (
            <button
              key={option}
              onClick={() => {
                setSelectedValue(option.toString());
                setShowDropdown(false);
                setCurrentPage(1);
              }}
              className={`${Styles.selectOption} ${
                selectedValue === option.toString()
                  ? Styles.selectOptionActive
                  : Styles.selectOptionInactive
              }`}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LucidDropdown;
